import Container = Phaser.GameObjects.Container;
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import BaseSound = Phaser.Sound.BaseSound;
import SoundUtils from "@/utils/sound-utils";
import Image = Phaser.GameObjects.Image;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";

export class Radio extends Container {

    private checked!: boolean;

    private check!: Image;

    constructor(scene: Scene, x: number, y: number, selectSound: BaseSound | undefined, checked: boolean, name: string,
                checkCallback: () => unknown) {
        super(scene);
        let self = this;
        this.x = x;
        this.y = y;
        this.checked = checked;
        let box = SpriteUtils.addImage(this.scene, 0, 0, Keys.FRM_RADIO_OUT, undefined, 0.65);
        this.check = SpriteUtils.addImage(this.scene, 0, 0, Keys.FRM_RADIO_IN, undefined, 0.65).setVisible(checked);

        let label = TextUtils.addTextAdvanced(this.scene, name, 20, 0,
            '#ffdfdf', 25, Fonts.MYRIADPRO_REGULAR, 500, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        let checkFn = () => {
            SoundUtils.play(selectSound);
            self.setChecked(true);
            checkCallback();
        };

        box.setInteractive().on('pointerup', checkFn);
        label.setInteractive().on('pointerup', checkFn);

        this.add([box, self.check, label]);
    }

    public setChecked(checked: boolean): void {
        this.checked = checked;
        this.check.setVisible(checked);
    }
}
